import axios from "axios";
import { ElNotification } from "element-plus";
import router from "@/router";


const service = axios.create({
    // baseURL: "http://localhost:8082/api/v1/",
    // baseURL: "http://192.168.2.58:8082/api/v1/",
    baseURL: "https://api.shenshimuseum.com/api/v1/",
    timeout: 5000,
    headers: {
        // "openid": user.openid,
        // "token": user.token,
        "Content-Type": "application/json;charset=utf-8",
        // "Access-Control-Allow-Origin": "*",
        // "Access-Control-Allow-Headers": "openid, token, Origin, X-Requested-With, Content-Type, Accept",
        // "Access-Control-Allow-Methods": "GET, POST"
    }
})
// 请求拦截
service.interceptors.request.use((config:any) => {
   
    config.headers = config.headers || {}
    
    return config
})
// 响应拦截
service.interceptors.response.use((res:any) => {
    const data: any = {
        data: res.data,
        code: res.status
    }

    if (data.code != 200) {
        return Promise.reject(res.data)
    }
    return data
}, (err:any) => {
    console.log(err);
    if (err.response) {
        const status: number = err.response.status
        if (status == 404) {
            ElNotification({
                title: '错误',
                message: '系统出错',
                type: 'error',
            })
        }
        if (status == 500) {
            ElNotification({
                title: '错误',
                message: '网络出错',
                type: 'error',
            })
        }
    }
    return Promise.reject(err)
})
export default service